<template>
    <div @click="onClick">
        <div class="inline field">
           <label> Document Id: </label>
           <span>{{rowData.DocumentId}}</span>
         </div>
         <div class="inline field">
           <label>Xref ID: </label>
           <span>{{rowData.XREFId}}</span>
         </div>
        <div class="inline field">
           <label>Doc Type: </label>
           <span>{{rowData.DocDescription}}</span>
         </div> 
         <div class="inline field">
           <label>Currency Name: </label>
           <span>{{rowData.CurrencyCode}}</span>
         </div>
         <div class="inline field">
           <label>Is Deleted: </label>
           <span>{{rowData.IsDeletedDescription}}</span>
         </div>
         <div class="inline field">
           <label>Routing: </label>
           <span>{{rowData.RoutingDescription}}</span>
         </div>
        
   </div>
   </template>
   
   <script>
   export default {
     props: {
       rowData: {
         type: Object,
         required: true
       },
       rowIndex: {
         type: Number
       }
     },
     methods: {
       onClick (event) {
               console.log('crossReferenceTraceLog-detail-row: on-click', event.target)
       }
     },
   }
   </script>
   
   


// WEBPACK FOOTER //
// src/components/integration-staging/CrossReferenceTraceDetailRow.vue